/* ==========================================================================
   DJ 产品详情页脚本（product.dj 模板）
   1) 主图缩略图切换
   2) 加入预购：真·AJAX 状态机

   按钮四态：
     idle     Preorder                     黑底、可点
     loading  Adding…  + 转圈               禁用，防止重复提交
     success  Added to Pre-Order           绿底，1.8s 后回 idle
     error    Add failed — try again       红底，1.8s 后回 idle 且可重试

   关键点：成功态只在 /cart/add.js 明确返回成功之后才出现。
   旧版是点击瞬间就切成功态（乐观更新），售罄 / 变体失效 / 请求失败时
   用户也会看到绿色的「Added to Pre-Order」，属于假成功。
   ========================================================================== */
(function () {
  'use strict';

  /* 成功 / 失败态在按钮上停留多久，由 section setting「cta_hold_ms」控制，
     默认 1800ms。改完不用动代码，编辑器里调滑杆即可。 */
  var DEFAULT_HOLD_MS = 1800;

  function readHoldMs(root) {
    var raw = parseInt(root.getAttribute('data-djp-hold'), 10);
    if (!isFinite(raw) || raw < 0) return DEFAULT_HOLD_MS;
    return raw;
  }

  /* ---------- 图片放大查看（灯箱） ----------
     单例：整页只建一个 overlay。任何带 data-djp-zoom 的图片点开都能看大图，
     同一 [data-djp-zoomgroup] 内的图片可以用左右键 / 箭头切换。
     商品主图特殊处理：它的列表来自缩略图，起点是当前选中的那张。 */
  var lightbox = (function () {
    var wrap, imgEl, countEl, prevBtn, nextBtn, closeBtn;
    var items = [], idx = 0, lastFocus = null;

    function ensure() {
      if (wrap) return;
      wrap = document.createElement('div');
      wrap.className = 'djp-lb';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.innerHTML =
        '<button type="button" class="djp-lb__close" aria-label="Close">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<button type="button" class="djp-lb__nav djp-lb__nav--prev" aria-label="Previous image" hidden>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>' +
        '</button>' +
        '<img class="djp-lb__img" alt="">' +
        '<button type="button" class="djp-lb__nav djp-lb__nav--next" aria-label="Next image" hidden>' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>' +
        '</button>' +
        '<div class="djp-lb__count"></div>';
      document.body.appendChild(wrap);

      imgEl = wrap.querySelector('.djp-lb__img');
      countEl = wrap.querySelector('.djp-lb__count');
      prevBtn = wrap.querySelector('.djp-lb__nav--prev');
      nextBtn = wrap.querySelector('.djp-lb__nav--next');
      closeBtn = wrap.querySelector('.djp-lb__close');

      closeBtn.addEventListener('click', close);
      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); step(1); });
      // 只有点在图片外的背景才关闭，点图片本身不关
      wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
      document.addEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (!wrap || !wrap.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    }

    function render() {
      var it = items[idx];
      if (!it) return;
      imgEl.src = it.src;
      imgEl.alt = it.alt || '';
      var multi = items.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      countEl.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
    }

    function step(d) {
      if (items.length < 2) return;
      idx = (idx + d + items.length) % items.length;
      render();
    }

    function open(list, start, trigger) {
      ensure();
      items = (list || []).filter(function (x) { return x && x.src; });
      if (!items.length) return;
      idx = Math.max(0, Math.min(start || 0, items.length - 1));
      lastFocus = trigger || document.activeElement;
      render();
      wrap.classList.add('is-open');
      document.body.classList.add('djp-lb-open');
      closeBtn.focus({ preventScroll: true });
    }

    function close() {
      if (!wrap) return;
      wrap.classList.remove('is-open');
      document.body.classList.remove('djp-lb-open');
      imgEl.removeAttribute('src');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    return { open: open, close: close };
  })();

  function zoomableItems(nodes) {
    return Array.prototype.map.call(nodes, function (n) {
      return {
        src: n.getAttribute('data-djp-full') || n.getAttribute('src') || '',
        alt: n.getAttribute('alt') || ''
      };
    });
  }

  /* 图片不是可聚焦元素，补 role/tabindex + 回车空格，键盘也能打开 */
  function makeOpenable(img, handler) {
    if (img.dataset.djpOpenable === '1') return;
    img.dataset.djpOpenable = '1';
    img.setAttribute('role', 'button');
    img.setAttribute('tabindex', '0');
    img.addEventListener('click', handler);
    img.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        handler(e);
      }
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.djpReady === '1') return;
    root.dataset.djpReady = '1';

    var holdMs = readHoldMs(root);
    /* ---------- 1. 缩略图切换 ---------- */
    var mainImg = root.querySelector('[data-djp-main-image]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-djp-thumb]'));
    var current = 0;
    var lastSwipeAt = 0;

    if (mainImg && thumbs.length) {

      /* 缩略图数量不限，统一走 activate：切换主图 + 高亮 + 让当前张滚进可视区 */
      var activate = function (i, bringIntoView) {
        var btn = thumbs[i];
        if (!btn) return;
        current = i;

        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var full = btn.getAttribute('data-djp-src');
        var set = btn.getAttribute('data-djp-srcset');
        if (full) {
          mainImg.setAttribute('src', full);
          if (set) {
            mainImg.setAttribute('srcset', set);
          } else {
            mainImg.removeAttribute('srcset');
          }
        }

        if (bringIntoView && btn.scrollIntoView) {
          btn.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      };

      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () { activate(i, true); });
      });

      /* 移动端：主图上左右滑也能切换（阈值 40px，竖向滚动不误触） */
      var startX = 0, startY = 0, tracking = false;

      mainImg.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { tracking = false; return; }
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      mainImg.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        var next = current + (dx < 0 ? 1 : -1);
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        activate(next, true);
        lastSwipeAt = Date.now();
      }, { passive: true });
    }

    /* ---------- 3. 点开大图 ---------- */
    var galleryItems = thumbs.map(function (btn) {
      return {
        src: btn.getAttribute('data-djp-full') || btn.getAttribute('data-djp-src'),
        alt: mainImg ? (mainImg.getAttribute('alt') || '') : ''
      };
    });

    if (mainImg) {
      makeOpenable(mainImg, function () {
        // 刚做完左右滑，别再顺手弹出大图
        if (Date.now() - lastSwipeAt < 400) return;
        if (galleryItems.length) {
          lightbox.open(galleryItems, current, mainImg);
        } else {
          lightbox.open(zoomableItems([mainImg]), 0, mainImg);
        }
      });
    }

    /* ---------- 2. 加入预购 ---------- */
    var form = root.querySelector('[data-djp-form]') || root.querySelector('form#djp-product-form') || root.querySelector('form[action*="/cart/add"]');
    var btn = root.querySelector('[data-djp-cta]');
    var toast = root.querySelector('[data-djp-toast]');
    if (!form || !btn) return;

    var isSubmitting = false;

    var labelIdle = btn.getAttribute('data-djp-label') || btn.textContent.trim();
    var labelDone = btn.getAttribute('data-djp-label-done') || labelIdle;
    var labelLoading = btn.getAttribute('data-djp-label-loading') || 'Adding\u2026';
    var labelError = btn.getAttribute('data-djp-label-error') || 'Add failed \u2014 try again';

    var states = ['idle', 'loading', 'success', 'error'];

    /* 统一改状态：class、文案、禁用三件事一起做，避免中间态错位 */
    function setState(state, text) {
      states.forEach(function (s) { btn.classList.remove('is-' + s); });
      if (state !== 'idle') btn.classList.add('is-' + state);
      btn.textContent = text;
      btn.disabled = (state === 'loading' || state === 'success');
    }

    function backToIdle() {
      setState('idle', labelIdle);
      isSubmitting = false;
    }

    function showToast() {
      if (!toast) return;
      toast.classList.add('is-show');
      setTimeout(function () { toast.classList.remove('is-show'); }, 2200);
    }

    /* 头部购物车角标是服务端渲染的，AJAX 加购后要自己同步一次，否则角标会停在旧数字。
       选择器覆盖两套主题的写法：
         2C-USA（ErideproTheme） → .cart-count-inside / .cart-count
         2B-USA（DealerHubV2）   → [data-cart-count] / [data-cart-count-mobile] / .header__cart-count
       都没匹配到就静默跳过。 */
    /* 2B-UK（Impulse 基座）的角标是 .count-style.bigcounter，见 snippets/mini-cart.liquid */
    var CART_COUNT_SELECTOR = '.cart-count-inside, .cart-count, [data-cart-count], [data-cart-count-mobile], .header__cart-count, .bigcounter, .count-style';

    function syncCartCount() {
      var nodes = document.querySelectorAll(CART_COUNT_SELECTOR);
      if (!nodes.length) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          nodes.forEach(function (n) { n.textContent = cart.item_count; });
        })
        .catch(function () {});
    }

    /* /cart/add.js 的错误有两种形态：
       非 2xx + JSON{description}，以及 200 + JSON{status:4xx}。
       两种都要当失败处理，只有解析成功且没有 error 字段才算加购成功。 */
    function parseAddResponse(res) {
      return res.text().then(function (raw) {
        var data = {};
        try { data = JSON.parse(raw) || {}; } catch (err) { data = {}; }

        var status = Number(data.status || res.status);
        var hasError = data.error || data.description || data.message;
        if (!res.ok || status >= 400 || (hasError && !data.id && !data.items)) {
          throw new Error(data.description || data.message || data.error || ('HTTP ' + res.status));
        }
        return data;
      });
    }

    form.addEventListener('submit', function (e) {
      if (isSubmitting) {
        e.preventDefault();
        return;
      }
      // 老浏览器没有 fetch/FormData：不拦，走原生提交（会跳 /cart，但至少能下单）
      if (!window.fetch || !window.FormData) return;

      e.preventDefault();
      isSubmitting = true;
      setState('loading', labelLoading);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(parseAddResponse)
        .then(function () {
          setState('success', labelDone);
          showToast();
          syncCartCount();
          setTimeout(backToIdle, holdMs);
        })
        .catch(function (err) {
          // 不再 form.submit() 兜底：原生跳转会把「失败」伪装成「成功」
          setState('error', labelError);
          if (window.console && console.warn) console.warn('[djp] add to cart failed:', err && err.message);
          setTimeout(backToIdle, holdMs);
        });
    });
  }

  /* 详情图 / 分栏图：整页有多个 .dj-pdp 根容器（首屏、参数、图文各一个），
     所以不能只对 data-djp-product 那个根绑定，必须按 .dj-pdp 逐个初始化。 */
  function initZoom(root) {
    if (!root || root.dataset.djpZoomReady === '1') return;
    root.dataset.djpZoomReady = '1';

    Array.prototype.forEach.call(root.querySelectorAll('[data-djp-zoom]:not([data-djp-zoom="main"])'), function (img) {
      makeOpenable(img, function () {
        var group = img.closest ? img.closest('[data-djp-zoomgroup]') : null;
        var nodes = group ? group.querySelectorAll('[data-djp-zoom]') : [img];
        lightbox.open(zoomableItems(nodes), Array.prototype.indexOf.call(nodes, img), img);
      });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.dj-pdp'), function (root) {
      initZoom(root);
      if (root.hasAttribute('data-djp-product')) initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // 主题编辑器里重新渲染 section 后重新初始化
  document.addEventListener('shopify:section:load', boot);
})();
